import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Subtle branded backdrop (circle-sparks) for landing sections.
 * Auto-selects the light/dark SVG via the active theme. Sits behind content
 * at low opacity so it never competes with text.
 *
 * Props:
 *   opacity - 0..1 (default 0.5; the SVG colors are already low-alpha)
 *   variant - 'auto' (light/dark by theme) | 'transparent' (currentColor)
 *   fade    - if true, fades out toward the bottom (good for hero)
 */
export default function SectionBackground({ opacity = 0.5, variant = 'auto', fade = false, strong = false }) {
  const { isDark } = useTheme();
  const suffix = strong ? '-strong' : '';
  const file =
    variant === 'transparent'
      ? 'circle-sparks-transparent'
      : isDark
      ? `circle-sparks-dark${suffix}`
      : `circle-sparks-light${suffix}`;
  const url = `${process.env.PUBLIC_URL || ''}/backgrounds/${file}.svg`;

  const style = {
    backgroundImage: `url("${url}")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    opacity,
  };
  if (fade) {
    // Concentrate the pattern at the top edges, easing it away behind the headline/CTAs.
    const mask = 'radial-gradient(130% 95% at 50% -5%, rgba(0,0,0,1) 0%, rgba(0,0,0,0.5) 55%, rgba(0,0,0,0) 88%)';
    style.WebkitMaskImage = mask;
    style.maskImage = mask;
  }

  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 z-0 pointer-events-none"
      style={style}
    />
  );
}
